module["exports"] = [
  "com",
  "com",
  "com",
  "net",
  "org",
  "it",
  "it",
  "it"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/internet/domain_suffix.js
// module id = 2437
// module chunks = 2